import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { Button } from "antd";
import { HomeOutlined, LogoutOutlined, MenuOutlined } from "@ant-design/icons";
import { all_routes } from "@/feature-module/router/all-routes";
import { useLogout } from "@/feature-module/auth/presentation/hooks/use-auth";

interface DashboardNavbarProps {
  onToggleSidebar?: () => void;
  isMobile?: boolean;
}

const DashboardNavbar = ({ onToggleSidebar, isMobile }: DashboardNavbarProps) => {
  const routes = all_routes;
  const { mutate: logout } = useLogout();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
  };

  return (
    <header className="dashboard-header">
      <div className="dashboard-header__left">
        {/* Mobile menu toggle button */}
        {isMobile && onToggleSidebar && (
          <Button
            icon={<MenuOutlined />}
            type="text"
            onClick={onToggleSidebar}
            className="dashboard-header__menu-button"
            aria-label="Toggle sidebar menu"
          />
        )}
        
        <h3 className="dashboard-header__title">Dashboard</h3>
      </div>

      <div className="dashboard-header__right">
        <Link to={routes.home}>
          <Button
            icon={<HomeOutlined />}
            type="default"
            className="dashboard-header__back-button"
          >
            Back to Website
          </Button>
        </Link>
        <Button
          icon={<LogoutOutlined />}
          danger
          onClick={handleLogout}
          className="dashboard-header__logout-button"
        >
          Logout
        </Button>
      </div>
    </header>
  );
};

export default DashboardNavbar;